__turbopack_context__.v({
  "hiddenSideBar-closed": "sidebar-module-scss-module__1OCHcG__hiddenSideBar-closed",
  "hiddenSideBar-open": "sidebar-module-scss-module__1OCHcG__hiddenSideBar-open",
  "sideBar-open": "sidebar-module-scss-module__1OCHcG__sideBar-open",
});
